import { ErrorComponentProps, ErrorRouteComponent } from '@tanstack/react-router';
import AlertBox from '@shared/components/AlertBox.tsx';
import { AxiosError } from 'axios';

const DefaultErrorComponent: ErrorRouteComponent = ({ error, reset }: ErrorComponentProps) => {
    const errorMessageBasedOnStatusCode = (status?: number) => {
        switch (status) {
            case 401: {
                return <>Du behöver vara inloggad för att se denna sida</>;
            }
            default:
                return <>Oväntat fel</>;
        }
    };
    const errorActionBasedOnStatusCode = (status?: number) => {
        switch (status) {
            case 401: {
                return (
                    <a
                        href='/'
                        className='btn btn-alert-danger'
                    >
                        Logga in
                    </a>
                );
            }
            default:
                return <></>;
        }
    };

    return (
        <div
            className='container-md mt-4'
            id='alert'
        >
            <AlertBox theme={'danger'}>
                <div className='flex-1'>
                    <h5 className='alert-heading'>Något gick fel</h5>

                    <div
                        id='error-details'
                        className='mb-2'
                    >
                        {error instanceof AxiosError ? errorMessageBasedOnStatusCode(error.status) : null}
                    </div>
                    <p>
                        Vid akuta frågor kontakta oss på:{' '}
                        <a
                            href='tel:010-480 30 00'
                            className='text-nowrap'
                        >
                            010-480 30 00
                        </a>
                        .
                    </p>
                    <div className='d-flex flex-wrap gap-2'>
                        {error instanceof AxiosError ? errorActionBasedOnStatusCode(error.status) : null}
                        <button
                            className='btn btn-alert-danger'
                            onClick={reset}
                        >
                            Prova igen
                        </button>
                    </div>
                </div>
            </AlertBox>
        </div>
    );
};

export default DefaultErrorComponent;
